import useSWR from 'swr';
import { outletService } from '../services';

interface IGetOutletProductsParams {
  offset: number;
  size: number;
  outlet_id: number;
  latitude: number | undefined;
  longitude: number | undefined;
  search?: string;
}

export function useOutletProducts(params: IGetOutletProductsParams) {
  const execute = async () => {
    const data = await outletService.getOutletProducts(params);
    return data;
  };

  const fetchKey = ['get-outlet-products', params];
  const { data, error, isLoading } = useSWR(fetchKey, execute);

  return {
    data,
    error,
    isLoading,
  };
}
